export type OperatingSystem = "windows" | "mac" | "unix" | "linux";

export function getOperatingSystem(): Nullable<OperatingSystem> {
    if (typeof window === "undefined") {
        return null;
    }

    if (window.navigator.userAgent.includes("Win")) {
        return "windows";
    }

    if (window.navigator.userAgent.includes("Mac")) {
        return "mac";
    }

    if (window.navigator.userAgent.includes("X11")) {
        return "unix";
    }

    if (window.navigator.userAgent.includes("Linux")) {
        return "linux";
    }

    return null;
}
